import { ChevronRight } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const RewardItem = (props) => {
  const { id, images, point, name, unit, quantity } = props;

  return (
    <Link to={`/reward/${id}`} style={{ textDecoration: 'none' }}>
      <Box sx={{ paddingLeft: '50px' }}>
        <Box
          sx={{
            width: '100%',
            backgroundColor: 'white',
            borderRadius: '10px',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 80px',
              gap: '10px',
              width: '100%',
              alignItems: 'center',
              paddingLeft: '40px',
              minHeight: '95px',
            }}
          >
            <Box
              component={'img'}
              src={images[0]}
              alt="Reward"
              sx={{
                width: '85px',
                position: 'absolute',
                top: '50%',
                left: '0',
                transform: 'translate(-50px, -50%)',
              }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '2px',
                padding: '2px 8px',
                height: '100%',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.25rem',
                  lineHeight: '1rem',
                  fontWeight: '500',
                  color: '#004B61',
                }}
              >
                แลกรับ
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.35rem',
                  fontWeight: '500',
                  lineHeight: '1.2rem',
                  color: '#E1000C',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {name} จำนวน {quantity} {unit}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <Typography sx={{ fontSize: '.85rem', fontWeight: '400', color: '#004B61' }}>
                  รายละเอียด
                </Typography>
                <ChevronRight sx={{ fontSize: '12px', color: '#004B61' }} />
              </Box>
            </Box>
            <Box
              sx={{
                width: '80px',
                height: '100%',
                backgroundColor: '#E1000C',
                textAlign: 'center',
                color: 'white',
                borderTopRightRadius: '10px',
                borderBottomRightRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontSize: '3rem', fontWeight: '500', lineHeight: '2rem' }}>
                {point || '0'}
              </Typography>
              <Typography sx={{ fontSize: '1.5rem', fontWeight: '500' }}>คะแนน</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Link>
  );
};

export default RewardItem;
